import { plural } from '../i18n'
import { dative, genitive, instrumental, past } from './russianName.js'
import type { ChildProfile } from './types.js'

/** Профиль ребёнка: возраст и формы имени. Порт `ChildProfile` из Kotlin. */

const WEEK_MILLIS = 7 * 24 * 3600 * 1000

export function ageWeeks(profile: ChildProfile, now: number): number {
  return Math.max(0, Math.trunc((now - profile.birthMillis) / WEEK_MILLIS))
}

/**
 * «10 недель» до 16 недель, дальше «5 месяцев».
 * Форма слова — по правилам текущего языка от того же округлённого числа, что и на экране:
 * Kotlin брал её от целой части, и «4,6» давало «5 месяца».
 */
export function ageText(profile: ChildProfile, now: number): string {
  return ageTextOf(profile.birthMillis, now)
}

/** То же по одной дате: при выборе даты рождения профиля ещё нет. */
export function ageTextOf(birthMillis: number, now: number): string {
  const weeks = Math.max(0, Math.trunc((now - birthMillis) / WEEK_MILLIS))
  if (weeks < 16) return plural(weeks, 'age_weeks')
  return plural(Math.round(weeks / 4.345), 'age_months')
}

/** Паши */
export function profileGenitive(profile: ChildProfile): string {
  return genitive(profile.name, profile.gender)
}

/** Паше */
export function profileDative(profile: ChildProfile): string {
  return dative(profile.name, profile.gender)
}

/** Пашей */
export function profileInstrumental(profile: ChildProfile): string {
  return instrumental(profile.name, profile.gender)
}

/** проснулся / проснулась */
export function profilePast(profile: ChildProfile, stem: string): string {
  return past(stem, profile.gender)
}
